const childrenLoaded = require("@alexspirgel/children-loaded");

class RelatedCoursesList extends ESWPPostList {

	constructor() {
		super();
	}
	async connectedCallback() {
		await childrenLoaded(this);
	}

}

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('post-list-related-courses-list', RelatedCoursesList, {extends: 'div'});
});
